var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0956 3.27452C23.823 2.24804 23.0198 1.43962 22 1.16527C20.1514 0.666748 12.7391 0.666748 12.7391 0.666748C12.7391 0.666748 5.32675 0.666748 3.47818 1.16527C2.45834 1.43966 1.65513 2.24804 1.38252 3.27452C0.887207 5.13506 0.887207 9.01692 0.887207 9.01692C0.887207 9.01692 0.887207 12.8988 1.38252 14.7593C1.65513 15.7858 2.45834 16.5605 3.47818 16.8349C5.32675 17.3334 12.7391 17.3334 12.7391 17.3334C12.7391 17.3334 20.1514 17.3334 22 16.8349C23.0198 16.5605 23.823 15.7858 24.0956 14.7593C24.5909 12.8988 24.5909 9.01692 24.5909 9.01692C24.5909 9.01692 24.5909 5.13506 24.0956 3.27452ZM10.3148 12.5414V5.49249L16.5101 9.01701L10.3148 12.5414Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.109685479368fc08ae879f4037696b3e.svg";
export { ForwardRef as ReactComponent };